module.exports = __webpack_public_path__ + "img/TechGatherStone2_ua.e321af15.webp";